import { useEffect, useState } from "react"
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import BottomCelebs from "./bottomCelebs";
import BottomUsers from "./bottomUsers";




export default function BottomPeople() {




    return (
        <div>

            <div className="mb-20 h-full w-full flex flex-row">

                <BottomCelebs></BottomCelebs>

                <BottomUsers></BottomUsers>

            </div>

        </div>
    )
}